<script lang="ts">
	import { openWeb3Modal } from '$lib/wallet/wallet';
</script>

<button
	on:click={openWeb3Modal}
	data-testid="connect-wallet-btn"
	class="flex justify-center items-center gap-3 text-fx-grey-900 font-semibold text-center rounded-xl squircle-xl bg-fx-gradient-9 py-4 cursor-pointer hover:scale-[1.01] transition-all duration-400 ease-in-out w-full"
>
	Connect Wallet
</button>
